<template>
    <div class="account-wrapper">
        <OperationBar @searchHandle="searchHandle"></OperationBar>
        <div class="account-content">
            <Table class="account-table-list" :config="tableConfig" :dataset="accountData" />
        </div>
        <div class="page-control">
            <PageControl :total="accountTotal" :curPage="curPage" :lengthRank="pageLengthRank" :pageLength="10" @pageChange="pageChange" />
        </div>
    </div>
</template>

<script>
import OperationBar from "./OperationBar";
import Table from "@/views/zhiji/bComponents/table/Table";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";

import { accountTableConfig } from "../../personConfig.js";
/* eslint-disable */
export default {
    name: "AccountManage",
    components: {
        OperationBar,
        Table,
        PageControl,
    },
    data() {
        return {
            curPage: 1,
            curPageLen: 10,
            pageLengthRank: 10,
        };
    },
    computed: {
        tableConfig() {
            return accountTableConfig();
        },
        accountData() {
            return this.getStorePorp("accountData");
        },
        accountTotal() {
            return this.getStorePorp("accountTotal");
        },
        i18nLocal() {
            return this.$i18n.locale;
        }
    },
    watch: {
        i18nLocal() {
            this.getAccountListData();
        }
    },
    mounted() {
        this.$store.commit("zhiji/initGroupQuerySet");
        this.getAccountListData();
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.personnelManage[propName];
        },
        searchHandle(data) {
            this.curPage = 1;
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;

            this.getAccountListData();
        },
        getAccountListData() {
            this.$store.dispatch("zhiji/queryAccountList", {
                page: this.curPage,
                size: this.curPageLen,
            });
        },
    }
};
</script>

<style lang="less" scoped>
.account-wrapper {
    margin: 16px 16px 16px 16px;
    padding: 0 24px 24px;
    background: #fff;
    border: 1px solid #d9e4ef;
    border-radius: 4px;

    .account-content {
        border-width: 0 1px 1px;
        border-style: solid;
        border-color: #e3ecf5;
        box-sizing: border-box;
    }

    .page-control {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0;
        text-align: center;
        color: rgba(65, 71, 94, 0.7);
    }
}
</style>
